import React, { useState } from 'react';
import styled from 'styled-components';
import { colors, breakpoints } from '../../../assets/styles/GlobalStyles';
import { FaFileAlt, FaCalendarAlt, FaHashtag, FaExchangeAlt } from 'react-icons/fa';
import { getContrastTextColor } from '../../../utils/colorUtils';
import TramitacaoModal from './TramitacaoModal';

const Card = styled.div`
  background: ${colors.white};
  border-radius: 16px;
  padding: 20px;
  margin-bottom: 16px;
  transition: all 0.3s ease;
  border: 1px solid rgba(0, 0, 0, 0.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    border-color: rgba(0, 112, 243, 0.2);
  }
`;

const CardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 16px;
  flex-wrap: wrap;
  gap: 12px;
`;

const ProtocoloTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: #1a2c3e;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 8px;

  svg {
    color: ${colors.darkBlue};
    font-size: 1.2rem;
  }
`;

const StatusBadge = styled.span`
  display: inline-flex;
  align-items: center;
  padding: 6px 14px;
  border-radius: 20px;
  font-size: 0.75rem;
  font-weight: 600;
  background-color: ${props => props.$bgColor || '#f0f0f0'};
  color: ${props => props.$textColor || '#333'};
  // Igual ao RequestCard: status longo quebra em vez de estourar o card
  max-width: 100%;
  overflow-wrap: anywhere;
`;

const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(min(200px, 100%), 1fr));
  gap: 12px;
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #eef2f6;
`;

const InfoItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 0.85rem;
  color: #5a6e7c;

  svg {
    color: ${colors.darkBlue};
    font-size: 0.9rem;
    opacity: 0.7;
  }

  strong {
    color: #1a2c3e;
    font-weight: 600;
    margin-right: 4px;
  }
`;

const CardFooter = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 12px;
`;

const TramitacaoButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background: ${colors.backgroundLight};
  border: 1px solid ${colors.borderLight};
  color: ${colors.darkBlue};
  font-size: 0.8rem;
  font-weight: 600;
  padding: 6px 12px;
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.2s ease;

  svg {
    font-size: 0.8rem;
  }

  &:hover {
    background: ${colors.lightBlue}15;
    border-color: ${colors.lightBlue};
  }

  @media (max-width: ${breakpoints.mobile}) {
    min-height: 40px;
    padding: 8px 14px;
  }
`;

const ProtocoloAndamentoCard = ({ protocolo }) => {
  const [modalAberto, setModalAberto] = useState(false);

  const statusColor = protocolo.statusCor || '#6c757d';
  const textColor = getContrastTextColor(statusColor);

  return (
    <Card>
      <CardHeader>
        <ProtocoloTitle>
          <FaFileAlt />
          {protocolo.tipoPedido}
        </ProtocoloTitle>
        <StatusBadge $bgColor={statusColor} $textColor={textColor}>
          {protocolo.statusLabel}
        </StatusBadge>
      </CardHeader>

      <InfoGrid>
        <InfoItem>
          <FaHashtag />
          <strong>Nº do Protocolo:</strong> {protocolo.numeroProtocolo}
        </InfoItem>
        <InfoItem>
          <FaCalendarAlt />
          <strong>Data do Protocolo:</strong> {protocolo.dataProtocolo}
        </InfoItem>
      </InfoGrid>

      <CardFooter>
        <TramitacaoButton onClick={() => setModalAberto(true)}>
          <FaExchangeAlt /> Ver trâmite
        </TramitacaoButton>
      </CardFooter>

      {modalAberto && (
        <TramitacaoModal protocolo={protocolo} onClose={() => setModalAberto(false)} />
      )}
    </Card>
  );
};

export default ProtocoloAndamentoCard;
